
import React from 'react';
import { TrendingUp, TrendingDown, Target, Gift, Tag, Coins, ArrowUp } from "lucide-react";

export const getIconComponent = (iconName?: string): React.ReactNode => {
  if (!iconName) return null;
  
  switch (iconName) {
    case "Coins":
      return <Coins size={16} />;
    case "TrendingUp":
      return <TrendingUp size={16} />;
    case "TrendingDown":
      return <TrendingDown size={16} />;
    case "Target":
      return <Target size={16} />;
    case "Gift":
      return <Gift size={16} />;
    case "Tag":
      return <Tag size={16} />;
    case "ArrowUp":
      return <ArrowUp size={16} />;
    default:
      return <TrendingUp size={16} />;
  }
};
